import { render, staticRenderFns } from "./button.vue?vue&type=template&id=b323286e&"
import script from "./button.ts?vue&type=script&lang=js&"
export * from "./button.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports